import { render, staticRenderFns } from "./InsertImmobile.vue?vue&type=template&id=d6344680&scoped=true&"
import script from "./InsertImmobile.vue?vue&type=script&lang=js&"
export * from "./InsertImmobile.vue?vue&type=script&lang=js&"
import style0 from "./InsertImmobile.vue?vue&type=style&index=0&id=d6344680&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6344680",
  null
  
)

export default component.exports